import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueMq from "vue-mq";
import "./ml";
import VueSVGIcon from "vue-svgicon";
import SocialSharing from "vue-social-sharing";
import VueLazyload from "vue-lazyload";
import Router from "vue-router";
import Meta from "vue-meta";
import Scrollmagic from 'scrollmagic';
// import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false;
Vue.use(VueSVGIcon);
Vue.use(SocialSharing);
Vue.use(VueLazyload);
Vue.use(Scrollmagic);
Vue.use(Router);
Vue.use(Meta);
// Vue.use(VueAnalytics, {
//   id: 'UA-27507131-11'
// });
Vue.use(VueMq, {
  breakpoints: {
    mobile: 769,
    tablet: 1200,
    desktop: Infinity
  }
});

Vue.prototype.$retina = window.devicePixelRatio > 1;

new Vue({
  router,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount("#app");
